var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xxxhdpi/Checkmark_green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-Entry-Details---Vehicle--(override-icon)",
    transform: "translate(-1214.000000, -365.000000)",
    fill: "#5f00a0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1221.984,380.616 L1230.984,371.616 L1229.568,370.152 L1221.984,377.76 L1218.432,374.184 L1217.016,375.6 L1221.984,380.616 Z M1224,365.616 C1225.82401,365.616 1227.51199,366.071995 1229.064,366.984 C1230.56801,367.848004 1231.752,369.031992 1232.616,370.536 C1233.528,372.088008 1233.984,373.775991 1233.984,375.6 C1233.984,377.424009 1233.528,379.111992 1232.616,380.664 C1231.752,382.168008 1230.56801,383.351996 1229.064,384.216 C1227.51199,385.128005 1225.82401,385.584 1224,385.584 C1222.17599,385.584 1220.48801,385.128005 1218.936,384.216 C1217.43199,383.335996 1216.248,382.144008 1215.384,380.64 C1214.472,379.087992 1214.016,377.408009 1214.016,375.6 C1214.016,373.791991 1214.472,372.112008 1215.384,370.56 C1216.264,369.055992 1217.45599,367.864004 1218.96,366.984 C1220.51201,366.071995 1222.19199,365.616 1224,365.616 Z",
    id: "Checkmark_green"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/check_circle_green.03a4ed72802a6d6258eeeee0efa74ca3.svg";
export { ForwardRef as ReactComponent };